module.exports = __webpack_public_path__ + "static/media/sore-throat.ae45f66a.svg";